import { getExpandingSquareSearchPoints, getXAxisSearchPoints } from "./getExpandingSquareSearch";

export const processReferenceScanDataPoint = (map, dataPoint, prevReferenceScanPhase) => {

    let nextPoints = [];
    let integrationTimes = [];
    let commands = [];
    let nextReferenceScanPhase = null;

    switch (prevReferenceScanPhase) {
        case 'calibrateY': {
            // const ySignalPoints = map.slice(-21).filter(p => Math.max(...p.processedSpectrum) > 100);
            const yPoints = map.slice(-21);
            let ySignalPoints = yPoints.filter(p => [p.signalToNoise >= 10.0, p.autocorrelationWidth >= 3, p.lowFrequencyEnergy >= 50].filter(Boolean).length >= 2 );
            if (ySignalPoints.length === 0 && yPoints.length > 0) {
                ySignalPoints.push(yPoints[Math.floor(yPoints.length / 2)]);
            }
            const minY = Math.min(...ySignalPoints.map(p => p.y));
            const maxY = Math.max(...ySignalPoints.map(p => p.y));
            const centerY = (minY + maxY) / 2;
            nextReferenceScanPhase = 'calibrateX';
            nextPoints = getXAxisSearchPoints({ x: dataPoint.x, y: centerY, z: dataPoint.z }, 8, 21);
            const nextPath = nextPoints.map((point, i) => [Math.round(point[0] * 1e6), Math.round(point[1] * 1e6), Math.round(point[2] * 1e6)]);
            integrationTimes = Array(nextPoints.length).fill(1000);
            commands = [
                ['laserON'],
                ['sendCoordinates', [...nextPath, ...nextPath]],
                ['scanCoordinates'],
                // ['laserOFF'],
                ['executeCommands']
            ];
            break;
        }
        case 'calibrateX':
            nextReferenceScanPhase = 'calibrateZ';
            const xPoints = map.slice(-21);
            let xSignalPoints = xPoints.filter(p => [p.signalToNoise >= 10.0, p.autocorrelationWidth >= 3, p.lowFrequencyEnergy >= 50].filter(Boolean).length >= 2 );
            if (xSignalPoints.length === 0 && xPoints.length > 0) {
                xSignalPoints.push(xPoints[Math.floor(xPoints.length / 2)]);
            }
            const minX = Math.min(...xSignalPoints.map(p => p.x));
            const maxX = Math.max(...xSignalPoints.map(p => p.x));
            const centerX = (minX + maxX) / 2;
            const bestPointCenter = { x: centerX, y: dataPoint.y, z: dataPoint.z };
            const params = { scanWidth: 1, scanHeight: 2, pointsPerSide: 1, numLevels: 21, singlePointMultiplier: 1 };
            nextPoints = getExpandingSquareSearchPoints(bestPointCenter, params.scanWidth, params.scanHeight, params.pointsPerSide, params.numLevels, params.singlePointMultiplier);
            const nextPath = nextPoints.map((point, i) => [Math.round(point[0] * 1e6), Math.round(point[1] * 1e6), Math.round(point[2] * 1e6)]);
            integrationTimes = Array(nextPoints.length).fill(500);
            commands = [
                ['laserON'],
                ['sendCoordinates', nextPath],
                ['scanCoordinates'],
                // ['laserOFF'],
                ['executeCommands']
            ];
            break;
        case 'calibrateZ':
            nextReferenceScanPhase = 'LowPowerStackedIntegrationTimeSweep';
            // const zCalibrationPoints = map.filter(p => p.x === dataPoint.x && p.y === dataPoint.y).sort((a, b) => Math.max(...b.processedSpectrum) - Math.max(...a.processedSpectrum));
            const zCalibrationPoints = map.slice(-21).sort((a, b) => Math.max(...b.processedSpectrum) - Math.max(...a.processedSpectrum));
            const bestPoint = zCalibrationPoints[0];
            // const bestPoint = {x: 12.25, y: 12.4, z: 14.5}
            integrationTimes = Array.from({ length: 65000 / 500 }, (_, i) => (i + 1) * 500);
            nextPoints = Array(integrationTimes.length).fill([bestPoint.x, bestPoint.y, bestPoint.z]);
            commands = [
                ['laserON'],
                ['setIntegrationTime', 500],
                ['sendCoordinates', Array(65000 / 500).fill([Math.round(bestPoint.x * 1e6), Math.round(bestPoint.y * 1e6), Math.round(bestPoint.z * 1e6)])],
                ['scanCoordinates'],
                // ['laserOFF'],
                ['executeCommands']
            ];
            break;
        case 'LowPowerStackedIntegrationTimeSweep': {
            nextReferenceScanPhase = 'LowPowerIntegrationTimeSweep';
            const requiredIntegrationTimes = [500, 1000, 2000, 3000, 4000, 5000];
            nextPoints = Array(requiredIntegrationTimes.length).fill([dataPoint.x, dataPoint.y, dataPoint.z]);
            // commands.push(['laserOFF'], ['setLaserPower', 1]);
            // for (let i = 0; i < requiredIntegrationTimes.length; i++) {
            //     integrationTimes.push(requiredIntegrationTimes[i]);
            //     commands.push(
            //         ['setIntegrationTime', requiredIntegrationTimes[i]],
            //         ['sendCoordinates', [Math.round(dataPoint.x * 1e6), Math.round(dataPoint.y * 1e6), Math.round(dataPoint.z * 1e6)]],
            //         ['scanCoordinates'],
            //     );
            // }
            // commands.push(['laserON'], ['setLaserPower', 45]);
            for (let i = 0; i < requiredIntegrationTimes.length; i++) {
                integrationTimes.push(requiredIntegrationTimes[i]);
                commands.push(
                    ['setIntegrationTime', requiredIntegrationTimes[i]],
                    ['sendCoordinates', [Math.round(dataPoint.x * 1e6), Math.round(dataPoint.y * 1e6), Math.round(dataPoint.z * 1e6)]],
                    ['scanCoordinates'],
                );
            }
            // commands.push(['laserOFF'], ['executeCommands']);
            commands.push(['executeCommands']);
            break;
        }
        case 'LowPowerIntegrationTimeSweep':
            nextReferenceScanPhase = 'LaserPowerSweep';
            commands = [['setIntegrationTime', 500], ['laserON']];
            for (let i = 0.1; i < 1; i += 0.1) {
                nextPoints.push([dataPoint.x, dataPoint.y, dataPoint.z]);
                commands.push(
                    ['setLaserPower', Math.round(i * 450)],
                    ['sendCoordinates', [Math.round(dataPoint.x * 1e6), Math.round(dataPoint.y * 1e6), Math.round(dataPoint.z * 1e6)]],
                    ['scanCoordinates']
                );
            }
            // commands.push(['laserOFF'], ['executeCommands']);
            commands.push(['executeCommands']);
            integrationTimes = Array(nextPoints.length).fill(500);
            break;
        case 'LaserPowerSweep':
            nextReferenceScanPhase = 'StackedIntegrationTimeSweep';
            integrationTimes = [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000];
            nextPoints = Array(integrationTimes.length).fill([dataPoint.x, dataPoint.y, dataPoint.z]);
            commands = [
                ['laserON'],
                ['setIntegrationTime', 500],
                ['sendCoordinates', Array(integrationTimes.length).fill([Math.round(dataPoint.x * 1e6), Math.round(dataPoint.y * 1e6), Math.round(dataPoint.z * 1e6)])],
                ['scanCoordinates'],
                // ['laserOFF'],
                ['executeCommands']
            ];
            break;
        case 'StackedIntegrationTimeSweep':
            nextReferenceScanPhase = 'IntegrationTimeSweep';
            const requiredIntegrationTimes = [500, 1000, 2000, 3000, 4000, 5000];
            nextPoints = Array(requiredIntegrationTimes.length).fill([dataPoint.x, dataPoint.y, dataPoint.z]);
            // commands.push(['laserOFF'], ['setLaserPower', 1]);
            // for (let i = 0; i < requiredIntegrationTimes.length; i++) {
            //     integrationTimes.push(requiredIntegrationTimes[i]);
            //     commands.push(
            //         ['setIntegrationTime', requiredIntegrationTimes[i]],
            //         ['sendCoordinates', [Math.round(dataPoint.x * 1e6), Math.round(dataPoint.y * 1e6), Math.round(dataPoint.z * 1e6)]],
            //         ['scanCoordinates'],
            //     );
            // }
            commands.push(['laserON'], ['setLaserPower', 450]);
            for (let i = 0; i < requiredIntegrationTimes.length; i++) {
                integrationTimes.push(requiredIntegrationTimes[i]);
                commands.push(
                    ['setIntegrationTime', requiredIntegrationTimes[i]],
                    ['sendCoordinates', [Math.round(dataPoint.x * 1e6), Math.round(dataPoint.y * 1e6), Math.round(dataPoint.z * 1e6)]],
                    ['scanCoordinates'],
                );
            }
            commands.push(['laserOFF'], ['executeCommands']);
            break;
    }
    return { commands, nextPoints, integrationTimes, nextReferenceScanPhase };

}